import { lazy } from 'react'
import { Bot } from 'lucide-react'

import { HIERARCHY_PERMISSIONS, SETTING_PERMISSIONS } from '@/lib/permissions'
import { ASSISTANT_POLICY_TYPE } from '../../api/assistant-policy-api'
import type { PolicyKindContribution } from './policy-kind'

export const assistantPolicyKind = {
  valueType: ASSISTANT_POLICY_TYPE,
  label: 'AI assistant',
  description: 'Enable or disable the assistant for this entity.',
  icon: Bot,
  order: 40,
  readPermission: HIERARCHY_PERMISSIONS.read,
  managePermission: SETTING_PERMISSIONS.edit,
  create: lazy(() => import('./create-assistant-policy').then((module) => ({
    default: module.CreateAssistantPolicy,
  }))),
  list: lazy(() => import('./assistant-policy-list').then((module) => ({
    default: module.AssistantPolicyList,
  }))),
} satisfies PolicyKindContribution
